import { render, staticRenderFns } from "./ProductSettingNewChic.vue?vue&type=template&id=4ea3ffa2&scoped=true&"
import script from "./ProductSettingNewChic.vue?vue&type=script&lang=js&"
export * from "./ProductSettingNewChic.vue?vue&type=script&lang=js&"
import style0 from "./ProductSettingNewChic.vue?vue&type=style&index=0&id=4ea3ffa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea3ffa2",
  null
  
)

export default component.exports